import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';

export const Nav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(7, 7, 26, 0.8);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  padding: 0 5vw;
`;

export const NavLogo = styled(LinkR)`
  text-decoration: none;
  display: flex;
  align-items: center;
`;

export const Span = styled.span`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  letter-spacing: -0.02em;
`;

export const NavItems = styled.ul`
  display: flex;
  align-items: center;
  gap: 2px;
  list-style: none;
  padding: 0;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  border-radius: 6px;
  font-size: 13.5px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  text-decoration: none;
  transition: color 0.2s, background 0.2s;

  .num {
    font-family: 'Space Grotesk', monospace;
    font-size: 10px;
    color: ${({ theme }) => theme.primary};
    opacity: 0.8;
  }

  &:hover {
    color: ${({ theme }) => theme.text_primary};
    background: rgba(255, 255, 255, 0.04);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const GitHubButton = styled.a`
  padding: 8px 20px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.border};
  background: transparent;
  color: ${({ theme }) => theme.primary};
  font-size: 13.5px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s, border-color 0.2s;

  &:hover {
    background: ${({ theme }) => theme.primary_light};
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const MobileIcon = styled.div`
  display: none;
  cursor: pointer;
  color: ${({ theme }) => theme.text_primary};
  padding: 6px;
  border-radius: 6px;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  @media (max-width: 900px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MobileMenu = styled.div`
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  background: rgba(7, 7, 26, 0.98);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  padding: 12px 5vw 20px;
  gap: 2px;
  animation: slideDown 0.18s ease;

  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-6px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const MobileLink = styled.a`
  padding: 11px 14px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: color 0.2s, background 0.2s;

  .num {
    font-family: 'Space Grotesk', monospace;
    font-size: 10px;
    color: ${({ theme }) => theme.primary};
  }

  &:hover {
    color: ${({ theme }) => theme.text_primary};
    background: rgba(255, 255, 255, 0.04);
  }
`;

export const MobileNavLogo = styled(LinkR)`
  text-decoration: none;
`;
